module.exports = __webpack_public_path__ + "320b9e81dff7221e844e8d634d982b8c.jpg";